import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getStations = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/stations?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}

export const getStation = async (stationId) => {
    const url = `/api/v1/stations/${stationId}`;

    const res = await axios.get(url);
    return res.data;
}

export const createStation = async (data) => {
    const url = `/api/v1/stations`;

    const res = await axios.post(url, data);
    return res.data;
}

export const updateStation = async (stationId, data) => {
    const url = `/api/v1/stations/${stationId}`;
    const res = await axios.put(url, data);
    return res.data;
}

export const deleteStation = async (stationId) => {
    const url = `/api/v1/stations/${stationId}`;
    const res = await axios.delete(url);
    return res.data;
}

export const exportStations = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/stations/export?${urlParams.toString()}`;
    const res = await axios.get(url, {responseType: 'blob'});
    const disposition = res.headers["content-disposition"];
    const fileName = disposition.split("filename=")[1];
    return {data: res.data, fileName};
}